const VIEW_MODES = new Set(['cards', 'list']);

export function readViewMode(storageKey, fallback = 'list') {
    if (!storageKey || typeof window === 'undefined') {
        return fallback;
    }
    try {
        const raw = String(localStorage.getItem(storageKey) || '').trim();
        return VIEW_MODES.has(raw) ? raw : fallback;
    } catch {
        return fallback;
    }
}

export function writeViewMode(storageKey, mode) {
    if (!storageKey || typeof window === 'undefined') {
        return;
    }
    const next = VIEW_MODES.has(mode) ? mode : 'list';
    try {
        localStorage.setItem(storageKey, next);
    } catch {
        // ignore quota / private mode
    }
}

export const JOBS_PRINTER_STATS_VIEW_KEY = 'acompanha.jobs.printerStatsView';
export const MAINTENANCES_PRINTER_SUMMARY_VIEW_KEY = 'acompanha.maintenances.printerSummaryView';
export const PRINTERS_LIST_VIEW_KEY = 'acompanha.printers.listView';
